import React, { useState, useEffect } from "react";
import { Header, Grid, Divider, Button } from "semantic-ui-react";
import { reduxForm, Field } from "redux-form";
import { renderTextField } from "../formcomponents";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
const DataInvIndiaCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;

  const [quantity, setQuantity] = useState(0);
  const [unitPrice, setUnitprice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const { id, catId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {}, []);

  const calculateAmount = (values) => {
    const total = quantity * unitPrice - discount;
    props.change("total", total.toFixed(2));

    // props.change("total", 123);
  };

  useEffect(() => {
    if (id != "null") {
      getWorkCatList();
    } else {
      // const tempData ={
      //   categoryId: Number(catId)
      // }
      // initializeData(tempData);
    }
  }, [id, catId]);
  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listDataEntry", {
        categoryId: 0,
        getAll: true,
        dataEntryId: 1,
      })
      .then((res) => {
        const filterData = res.data.find((item) => item.dataEntryId == id);

        console.log("filtered data", filterData);

        initializeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initializeData = (data) => {
    props.initialize({
      ...data,
    });

    setQuantity(data.quantity);
    setUnitprice(data.unitPrice);
    setDiscount(data.discount);
  };

  useEffect(() => {
    calculateAmount();
  }, [quantity, unitPrice, discount]);

  const sumbitForm = async (values) => {
    if (id != "null") {
    }
    console.log("values", values);
    const tempObject = {
      ...values,
      categoryId: id != "null" ? values.categoryId : catId,
    };
    console.log("values", tempObject);
    await axios
      .post(BaseUrlInvoice + "accounts/createDataEntry", tempObject)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errorCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        } else if (res.data.errorCode === 283) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Invoice (INDIA)
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="six">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="entryDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="name"
                label="Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="description"
                label="Description"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="item"
                label="Item"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="ticketType"
                label="Ticket Type"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="aed"
                label="AED"
                type="number"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="quantity"
                label="Quantity"
                type="text"
                onChange={(e) => {
                  setQuantity(e.target.value);
                  calculateAmount();
                }}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="unitPrice"
                label="Price"
                type="text"
                onChange={(e) => {
                  setUnitprice(e.target.value);
                  calculateAmount();
                }}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="discount"
                label="Discount"
                type="text"
                onChange={(e) => {
                  setDiscount(e.target.value);
                  calculateAmount();
                }}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="total"
                label="Total"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="remarks"
                label="Remarks"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider />
      <>
        {" "}
        <Button
          floated="right"
          positive
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "DataInvIndiaCreate",
})(DataInvIndiaCreate);
